module.exports = __webpack_public_path__ + "static/media/6_kitchen.749e689f.jpg";